// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:export {
  primaryColor: #007796;
  errorColor: #d9001b;
  warningColor: #f59a23;
  successColor: #63a103;
  backgroundColor: #272524;
}

.panel {
  position: absolute;
  background-color: #272524;
  border-radius: 0.5rem;
}
.panel .panel-header {
  padding: 1rem;
  font-size: 15px;
  border-bottom: 1px solid #1d1a19;
}
.panel .panel-content {
  font-size: 12px;
  padding: 0.5rem 1rem;
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
}
.panel .panel-content label div {
  width: 15rem;
}
.panel .panel-content label span {
  font-size: 12px;
}
.panel .panel-footer {
  padding: 0.5rem 1rem 1rem 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.panel .panel-footer button {
  min-width: 8rem;
}`, "",{"version":3,"sources":["webpack://./src/styles/colors.module.scss","webpack://./src/components/Elements/panelElement.scss"],"names":[],"mappings":"AA2BA;EACE,qBA5Bc;EA6Bd,mBA5BY;EA6BZ,qBA5Bc;EA6Bd,qBA5Bc;EA6Bd,wBA5BiB;ACEnB;;AAJA;EACE,kBAAA;EACA,yBAAA;EACA,qBAAA;AAOF;AALE;EACE,aAAA;EACA,eAAA;EACA,gCAAA;AAOJ;AAJE;EACE,eAAA;EACA,oBAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;AAMJ;AAHM;EACE,YAAA;AAKR;AAFM;EACE,eAAA;AAIR;AACE;EACE,8BAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AACJ;AACI;EACE,eAAA;AACN","sourcesContent":["$primary-color: #007796;\n$error-color: #d9001b;\n$warning-color: #f59a23;\n$success-color: #63a103;\n$background-color: #272524;\n$background-color-opacity: rgba(29, 26, 25, 0.85);\n$button-contained-background-color: #00538a;\n$button-contained-text-color: #fff;\n$button-contained-border-color: #00538a;\n\n$button-outlined-background-color: #363433;\n$button-outlined-text-color: #fff;\n$button-outlined-border-color: #363433;\n\n$icon-color: #919191;\n$svg-color: #cdcccc;\n$badge-color: #e04545;\n\n$input-background-color: #1d1a19;\n$table-odd-row-background-color: #1d1a19;\n\n$text-color: #d7d6d6;\n$text-color-light: #282929;\n$link-color: #02a4ff;\n$border-color: #1d1a19;\n\n\n:export {\n  primaryColor: $primary-color;\n  errorColor: $error-color;\n  warningColor: $warning-color;\n  successColor: $success-color;\n  backgroundColor: $background-color;\n}","@use \"../../styles/colors.module.scss\" as *;\n\n.panel {\n  position: absolute;\n  background-color: $background-color;\n  border-radius: .5rem;\n\n  .panel-header {\n    padding: 1rem;\n    font-size: 15px;\n    border-bottom: 1px solid $border-color;\n  }\n\n  .panel-content {\n    font-size: 12px;\n    padding: .5rem 1rem;\n    display: flex;\n    flex-direction: column;\n    row-gap: 1rem;\n\n    label {\n      div {\n        width: 15rem;\n      }\n\n      span {\n        font-size: 12px;\n      }\n    }\n  }\n\n  .panel-footer {\n    padding: 0.5rem 1rem 1rem 1rem;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n\n    button {\n      min-width: 8rem;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
